import { render } from "./App.vue?vue&type=template&id=36fafbf1"
const script = {}

import exportComponent from "C:\\Users\\teamh\\OneDrive\\Desktop\\Work\\gfe-system-web-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__